import {UpdateTeacherProvider} from "context/UpdateTeacherContext";
import {Navigate} from "react-router-dom";
import {ClassListing} from "./classListing/ClassListing";
import {HomeInstructor} from "./homeInstructor/HomeInstructor";
import {Notifications} from "./notifications/Notifications";
import {InstructorSettings} from "./settings/Settings";

const basePath = "/instructor";

const createRoute = (path) => `${basePath}/${path}`;

export const instructorRoute = {
    index: basePath,
    homeInstructor: createRoute("home-instructor"),
    classListing: createRoute("class-listing"),
    notifications: createRoute("notifications"),
    settings: createRoute("settings"),
};

export const instructorRouter = [
    {
        index: true,
        element: <Navigate to={instructorRoute.homeInstructor} replace/>,
    },
    {
        path: instructorRoute.homeInstructor,
        element: <HomeInstructor/>,
    },

    {
        path: instructorRoute.classListing,
        element: <UpdateTeacherProvider children={<ClassListing/>}/>,
    },
    {
        path: instructorRoute.notifications,
        element: <Notifications/>,
    },
    {
        path: instructorRoute.settings,
        element: <InstructorSettings/>,
    },
];
